import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import {
    CREATE_FEEDBACK_DETAILS_FAILURE,
    CREATE_FEEDBACK_DETAILS_FORM,
    CREATE_FEEDBACK_DETAILS_REQUEST,
    CREATE_FEEDBACK_DETAILS_SUCCESS,
    DELETE_FEEDBACK_DETAILS_FAILURE,
    DELETE_FEEDBACK_DETAILS_REQUEST,
    DELETE_FEEDBACK_DETAILS_SUCCESS,
    FETCH_FEEDBACK_DATA_FROM_PROPERTY_FAILURE,
    FETCH_FEEDBACK_DATA_FROM_PROPERTY_REQUEST,
    FETCH_FEEDBACK_DATA_FROM_PROPERTY_SUCCESS,
    FETCH_FEEDBACK_DETAILS_FAILURE,
    FETCH_FEEDBACK_DETAILS_REQUEST,
    FETCH_FEEDBACK_DETAILS_SUCCESS,
    FETCH_SINGLE_FEEDBACK_DETAILS_FAILURE,
    FETCH_SINGLE_FEEDBACK_DETAILS_REQUEST,
    FETCH_SINGLE_FEEDBACK_DETAILS_SUCCESS,
    RESET_FEEDBACK_DETAILS_INFO,
    UPDATE_FEEDBACK_DETAILS_FAILURE,
    UPDATE_FEEDBACK_DETAILS_REQUEST,
    UPDATE_FEEDBACK_DETAILS_SUCCESS
} from './feedbackDetails.actionType';

// FETCH FEEDBACK DETAILS DATA
export let fetchFeedbackDetailsWithIdData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.feedbackDetailsGET_BY_ID}?FldFKFeedback=${id}`,
        responseTypeRequest: FETCH_FEEDBACK_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_FEEDBACK_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_FEEDBACK_DETAILS_FAILURE
    };
    return axiosCall(config);
};

// CREATE FEEDBACK DETAILS FORM
export let createFeedbackDetailsForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_FEEDBACK_DETAILS_FORM, payload: { key, value } });
    };
};

// CREATE FEEDBACK DETAILS
export let createFeedbackDetails = (formData, modalClose, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        ...formData,
        fldFKFeedback: parseInt(formData.fldFKFeedback),
        fldFKType: parseInt(formData.fldFKType),
        fldFKStatus: parseInt(formData.fldFKStatus)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.feedbackDetailsPOST}`,
        responseTypeRequest: CREATE_FEEDBACK_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_FEEDBACK_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_FEEDBACK_DETAILS_FAILURE,
        resetFormData: RESET_FEEDBACK_DETAILS_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchFeedbackDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};

// GET SINGLE FEEDBACK DETAILS
export let getSingleFeedbackDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.feedbackDetailsGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_FEEDBACK_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_FEEDBACK_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_FEEDBACK_DETAILS_FAILURE,
        singlApiArray: [fetchFeedbackDataFromProperty(50), fetchFeedbackDataFromProperty(51)]
    };
    return axiosCall(config);
};

//UPDATE FEEDBACK DETAILS
export let updateFeedbackDetails = (formData, id) => {
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString(),
        fldFKFeedback: parseInt(formData.fldFKFeedback),
        fldNoOfDaysRequired: parseInt(formData.fldNoOfDaysRequired),
        fldFKStatus: parseInt(formData.fldFKStatus)
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.feedbackDetailsPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_FEEDBACK_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_FEEDBACK_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_FEEDBACK_DETAILS_FAILURE,
        resetFormData: RESET_FEEDBACK_DETAILS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchFeedbackDetailsWithIdData(id)
    };
    return axiosCall(config);
};

// DELETE FEEDBACK DETAILS
export let deleteFeedbackDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.feedbackDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_FEEDBACK_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_FEEDBACK_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_FEEDBACK_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchFeedbackDetailsWithIdData(parentId)
    };
    return axiosCall(config);
};

// FETCH FEEDBACK TYPE DATA
export let fetchFeedbackDataFromProperty = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_FEEDBACK_DATA_FROM_PROPERTY_REQUEST,
        responseTypeSuccess: FETCH_FEEDBACK_DATA_FROM_PROPERTY_SUCCESS,
        responseTypeFailure: FETCH_FEEDBACK_DATA_FROM_PROPERTY_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};
